(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
const initializeCategoryLoops = (root = document) => {
  root.querySelectorAll('.collection-list-wrapper slider-component').forEach(component => {
    if (!component.closest('[id*="collection_list_MgriNm"], [id*="collection_list_U4cFeF"]')) return;
    if (component.dataset.almaraLoopReady === 'true') return;
    const slider = component.querySelector('[id^="Slider-"]');
    const previous = component.querySelector('button[name="previous"]');
    const next = component.querySelector('button[name="next"]');
    if (!slider || !previous || !next) return;
    const originals = Array.from(slider.querySelectorAll('[id^="Slide-"]'));
    if (originals.length < 2) return;
    const clone = original => {
      const copy = original.cloneNode(true);
      copy.removeAttribute('id');
      copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      copy.setAttribute('aria-hidden', 'true');
      copy.dataset.almaraLoopClone = 'true';
      copy.querySelectorAll('a,button,[tabindex]').forEach(el => el.tabIndex = -1);
      return copy;
    };
    originals.slice().reverse().forEach(el => slider.prepend(clone(el)));
    originals.forEach(el => slider.append(clone(el)));
    component.dataset.almaraLoopReady = 'true';
    component.enableSliderLooping = true;
    slider.style.setProperty('scroll-snap-type', 'none', 'important');
    slider.style.setProperty('scroll-behavior', 'auto', 'important');
    previous.disabled = false;
    next.disabled = false;
    const measure = () => {
      const step = originals[1].getBoundingClientRect().left - originals[0].getBoundingClientRect().left;
      return {step, start: originals.length * step, span: originals.length * step};
    };
    let frame = 0, moving = false, timer = 0;
    const queue = [];
    const jump = left => slider.scrollTo({left, behavior: 'instant'});
    const normalize = () => {
      const {start, span} = measure();
      if (!Number.isFinite(span) || span <= 0) return;
      let left = slider.scrollLeft;
      while (left < start - 2) left += span;
      while (left >= start + span - 2) left -= span;
      if (Math.abs(left - slider.scrollLeft) > 2) jump(left);
    };
    const run = () => {
      if (moving || !queue.length) return;
      const direction = queue.shift();
      normalize();
      const {step, start} = measure();
      if (!Number.isFinite(step) || step <= 0) return;
      const from = start + Math.round((slider.scrollLeft - start) / step) * step;
      const target = from + direction * step;
      jump(from);
      moving = true;
      const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 320;
      let began;
      const tick = now => {
        began ??= now;
        const progress = duration ? Math.min(1, (now - began) / duration) : 1;
        const eased = 1 - Math.pow(1 - progress, 3);
        jump(from + (target - from) * eased);
        if (progress < 1) frame = requestAnimationFrame(tick);
        else { frame = 0; moving = false; normalize(); run(); }
      };
      frame = requestAnimationFrame(tick);
    };
    component.addEventListener('click', event => {
      const button = event.target.closest('button[name="previous"],button[name="next"]');
      if (!button || !component.contains(button)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      queue.push(button.name === 'next' ? 1 : -1);
      run();
    }, true);
    slider.addEventListener('pointerdown', () => {
      cancelAnimationFrame(frame);
      frame = 0; moving = false; queue.length = 0;
    }, {passive:true});
    slider.addEventListener('scroll', () => {
      clearTimeout(timer);
      if (!moving) timer = setTimeout(normalize, 180);
    }, {passive:true});
    let width = slider.clientWidth;
    new ResizeObserver(() => {
      if (slider.clientWidth === width) return;
      width = slider.clientWidth;
      cancelAnimationFrame(frame);
      moving = false; queue.length = 0;
      jump(measure().start);
    }).observe(slider);
    requestAnimationFrame(() => jump(measure().start));
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeCategoryLoops());
else initializeCategoryLoops();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  const initializeFeaturedCollectionLoops = (root = document) => {
    root.querySelectorAll('.collection slider-component').forEach((component) => {
      if (component.dataset.almaraLoopReady === 'true') return;

      const slider = component.querySelector('[id^="Slider-"]');
      const previousButton = component.querySelector('button[name="previous"]');
      const nextButton = component.querySelector('button[name="next"]');
      if (!slider || !previousButton || !nextButton) return;

      const originalSlides = Array.from(slider.querySelectorAll('[id^="Slide-"]'));
      if (originalSlides.length < 2) return;
      /* Nothing to scroll (all cards already fit): no copies, or they show up as repeated products. */
      if (slider.scrollWidth <= slider.clientWidth + 2) return;

      const cloneCount = Math.min(4, originalSlides.length);
      const prepareClone = (slide) => {
        const clone = slide.cloneNode(true);
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        /* The copies must stay clickable: the slider can rest on a copy (or
           the shopper can tap one mid-scroll), and an inert copy swallows the
           tap so the card never opens its product page. Only keep them out of
           keyboard tab order and screen readers. */
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a, button, input, select, textarea').forEach((element) => element.setAttribute('tabindex', '-1'));
        clone.dataset.almaraLoopClone = 'true';
        clone.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; image.fetchPriority = 'low'; });
        return clone;
      };

      originalSlides
        .slice(-cloneCount)
        .reverse()
        .forEach((slide) => slider.prepend(prepareClone(slide)));
      originalSlides.slice(0, cloneCount).forEach((slide) => slider.append(prepareClone(slide)));

      component.dataset.almaraLoopReady = 'true';
      component.enableSliderLooping = true;
      previousButton.removeAttribute('disabled');
      nextButton.removeAttribute('disabled');

      const jumpWithoutAnimation = (position) => {
        const previousBehavior = slider.style.scrollBehavior;
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = position;
        slider.getBoundingClientRect();
        slider.style.scrollBehavior = previousBehavior;
      };

      const getMeasurements = () => {
        const offset = Math.abs(originalSlides[1].getBoundingClientRect().left - originalSlides[0].getBoundingClientRect().left);
        return {
          offset,
          originalStart: cloneCount * offset - (matchMedia("(max-width: 749px)").matches ? (slider.clientWidth - originalSlides[0].getBoundingClientRect().width) / 2 : 0),
          loopWidth: originalSlides.length * offset,
        };
      };

      requestAnimationFrame(() => {
        const { originalStart } = getMeasurements();
        jumpWithoutAnimation(originalStart);
      });

      let width = slider.clientWidth;
      new ResizeObserver(() => {
        if (width !== slider.clientWidth) { width = slider.clientWidth; jumpWithoutAnimation(getMeasurements().originalStart); }
      }).observe(slider);

      let settleTimer;
      slider.addEventListener(
        'scroll',
        () => {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(() => {
            const { originalStart, loopWidth } = getMeasurements();
            if (slider.scrollLeft < originalStart - 2) {
              jumpWithoutAnimation(slider.scrollLeft + loopWidth);
            } else if (slider.scrollLeft >= originalStart + loopWidth - 2) {
              jumpWithoutAnimation(slider.scrollLeft - loopWidth);
            }
          }, 120);
        },
        { passive: true }
      );

      component.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest('button[name="previous"], button[name="next"]');
          if (!button || !component.contains(button)) return;

          event.preventDefault();
          event.stopPropagation();

          const { offset } = getMeasurements();
          const direction = button.name === 'next' ? 1 : -1;
          component.setSlidePosition(slider.scrollLeft + direction * offset);
        },
        true
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeFeaturedCollectionLoops());
  } else {
    initializeFeaturedCollectionLoops();
  }

  document.addEventListener('shopify:section:load', (event) => initializeFeaturedCollectionLoops(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  const almaraFooterMedia = window.matchMedia('(max-width: 749px)');
  const almaraFooterAccordions = document.querySelectorAll('.almara-footer__accordion');

  const syncAlmaraFooterAccordions = () => {
    almaraFooterAccordions.forEach((accordion) => {
      if (almaraFooterMedia.matches) {
        accordion.removeAttribute('open');
      } else {
        accordion.setAttribute('open', '');
      }
    });
  };

  syncAlmaraFooterAccordions();
  almaraFooterMedia.addEventListener('change', syncAlmaraFooterAccordions);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.footer = document.querySelector('.footer');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.headerSizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerSizeObserver.observe(this.header);
      if (this.announcementBar) this.headerSizeObserver.observe(this.announcementBar);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (this.announcementBar) {
        document.documentElement.style.setProperty(
          '--announcement-bar-height',
          `${this.announcementBar.offsetHeight}px`
        );
      }
    }

    disconnectedCallback() {
      if (this.headerSizeObserver) this.headerSizeObserver.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        const footerInView = this.footer && this.footer.getBoundingClientRect().top < window.innerHeight;
        if (!this.preventReveal && !footerInView) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.announcementBar) {
        this.announcementBar.classList.add('shopify-section-header-sticky', 'animate');
        this.announcementBar.classList.remove('shopify-section-header-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.announcementBar) {
        this.announcementBar.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
